import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { timer } from 'rxjs';
import { TicketDetailsComponent } from 'src/app/ticket-details/ticket-details.component';
import { CommonDataService } from 'src/sb-tools/typescript/services/common-data.service';
import { NoteService } from 'src/app/core/services/note.service';
import { ForwardMessageService } from 'src/app/core/services/forward-message.service';
import { ReplyService } from 'src/app/core/services/ticket/reply.service';
import { ThreadElementDTO } from '@sb-tools/typescript/models/dto/thread-element.dto';
import { ForwardEntityTypeEnum } from 'src/app/core/enums/forward-entity-type.enum';
import { DetailedTicketDTO } from '../../../../core/models/dto/detailed-ticket.dto';
import { getUrlWithQueryParams } from '../../../../core/utils/get-url-with-query-params.util';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { InlineSVGComponent } from '../../../../../sb-modules/Frontend-Inline-SVG-Module/inline-svg.component';
import { NgClass } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { ClipboardModule } from 'ngx-clipboard';
import { ReminderMenuComponent } from '../../../../shared/components/reminder-menu/reminder-menu.component';
import { isInboxElementVisible } from '../../../../core/utils/is-inbox-element-visible.util';

@Component({
    selector: 'app-reply-chat-menu',
    templateUrl: './reply-chat-menu.component.html',
    styleUrls: ['./reply-chat-menu.component.scss'],
    imports: [
        BsDropdownModule,
        TooltipModule,
        InlineSVGComponent,
        NgClass,
        TranslateModule,
        ClipboardModule,
        ReminderMenuComponent,
    ],
})
export class ReplyChatMenuComponent implements OnInit, AfterViewInit {
    @ViewChild('replyMenuBtn') replyMenuBtn: ElementRef;

    @Input() reply: ThreadElementDTO;
    @Input() parent: TicketDetailsComponent;
    @Input() ticket: DetailedTicketDTO;

    @Output() pickDateAndTimeClick: EventEmitter<void> = new EventEmitter();
    @Output() remindClick: EventEmitter<number> = new EventEmitter();
    @Output() removeReminderClick: EventEmitter<void> = new EventEmitter();

    forwardEntityTypeEnum = ForwardEntityTypeEnum;
    isReplyMenuDropUp: boolean;
    isReminderMenuDropUp: boolean;
    replyUrl: string;
    readonly isInboxElementVisible = isInboxElementVisible;

    constructor(
        public commonDataService: CommonDataService,
        public noteService: NoteService,
        public forwardMessageService: ForwardMessageService,
        private replyService: ReplyService,
    ) {}

    ngOnInit(): void {
        if (this.reply.id) {
            this.replyUrl = getUrlWithQueryParams({
                additionalParams: { ticketId: this.ticket.id, replyId: this.reply.id },
                withCurrentParams: false,
            });
        }
    }

    ngAfterViewInit() {
        if (!this.replyMenuBtn) {
            return;
        }

        this.replyMenuBtn.nativeElement.addEventListener('mouseenter', () => {
            this.initDropdownsPositioning();
        });

        timer(50).subscribe(() => {
            this.initDropdownsPositioning();
        });
    }

    initDropdownsPositioning(): void {
        if (!this.replyMenuBtn) {
            return;
        }

        const [isReplyMenuDropUp, isReminderMenuDropUp] = this.replyService.getReplyMenusDropUp(this.replyMenuBtn);
        this.isReplyMenuDropUp = isReplyMenuDropUp;
        this.isReminderMenuDropUp = isReminderMenuDropUp;
    }
}
